import React, { useEffect, useState } from "react";
import { LogIn, ShieldCheck, KeyRound } from "lucide-react";
import { api } from "@/lib/api";

export default function AdminLogin() {
  const [claimed, setClaimed] = useState(true);
  const [setupCode, setSetupCode] = useState("");

  useEffect(() => {
    api.get("/auth/setup-status").then(({ data }) => setClaimed(data.claimed)).catch(() => setClaimed(true));
  }, []);

  const login = () => {
    if (!claimed) {
      localStorage.setItem("agrivoire_setup_code", setupCode.trim());
    }
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0A0A0A] px-5" data-testid="admin-login-page">
      <div className="w-full max-w-md rounded-3xl border border-white/10 bg-white/[0.03] p-10 text-center">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-[#8CC63F] to-[#4E7D2C] text-white">
          <ShieldCheck className="h-7 w-7" />
        </div>
        <h1 className="mt-6 font-montserrat text-2xl font-black text-white">
          <span className="text-[#F5821F]">Agrivoire</span> <span className="text-[#1CADE4]">Export</span>
        </h1>
        <p className="mt-2 font-poppins text-sm text-white/50">Administration du contenu</p>

        {!claimed && (
          <div className="mt-8 text-left" data-testid="setup-block">
            <div className="rounded-xl border border-[#FFD700]/30 bg-[#FFD700]/5 p-4">
              <p className="font-poppins text-xs leading-relaxed text-[#FFD700]/90">
                <KeyRound className="mr-1 inline h-3.5 w-3.5" />
                Première configuration : entrez votre code de configuration pour lier votre compte Google comme administrateur.
              </p>
            </div>
            <label className="mt-4 block font-poppins text-xs font-medium text-white/60">Code de configuration</label>
            <input
              value={setupCode}
              onChange={(e) => setSetupCode(e.target.value)}
              data-testid="setup-code-input"
              placeholder="AGRIVOIRE-ADMIN-..."
              className="mt-1.5 w-full rounded-xl border border-white/15 bg-white/5 px-4 py-3 font-poppins text-sm text-white outline-none focus:border-[#8CC63F]"
            />
          </div>
        )}

        <button
          onClick={login}
          disabled={!claimed && !setupCode.trim()}
          data-testid="google-login-btn"
          className="mt-8 flex w-full items-center justify-center gap-3 rounded-full bg-white px-6 py-3.5 font-poppins text-sm font-semibold text-neutral-900 transition-transform duration-300 hover:scale-[1.02] disabled:opacity-50"
        >
          <LogIn className="h-4 w-4" />
          Se connecter avec Google
        </button>
        <p className="mt-6 font-poppins text-xs text-white/30">
          {claimed ? "Accès réservé aux administrateurs autorisés." : "Après cette étape, seul votre compte aura accès."}
        </p>
      </div>
    </div>
  );
}
